import { useSuperAdminShopConfiguration } from "@babackapp/private-api-client/client/use-super-admin-shop-configuration";
import { useAdminShop } from "./admin-shop-screens";
import { AdminPageShell } from "./admin-tab-pages";
import { ShopAccountSection, ShopClientSection } from "./shop-account-sections";
import { ShopPlanSection } from "./shop-plan-sections";
import { ShopSettingsSection } from "./shop-settings-viewer";

/**
 * Everything Care knows and sets about a shop (BBS-406): its client, its
 * plan, internal fields, and the merchant's own settings, read only.
 */
export function AdminShopConfigurationPage() {
  const { shopId, shopName } = useAdminShop();
  const { data, isPending, isError } = useSuperAdminShopConfiguration(shopId);

  return (
    <AdminPageShell
      title={`Configuration · ${shopName}`}
      description="Le super admin fait foi pour le plan et la relation client. Chaque changement est tracé dans le journal de la boutique."
    >
      {isPending ? (
        <p className="text-sm text-muted-foreground">Chargement…</p>
      ) : isError || !data ? (
        <p className="text-sm text-destructive">
          Impossible de charger la configuration.
        </p>
      ) : (
        <>
          <ShopClientSection
            key={`client-${shopId}`}
            shopId={shopId}
            shopName={shopName}
            client={data.account.client}
          />
          <ShopPlanSection
            key={`plan-${shopId}`}
            shopId={shopId}
            plan={data.plan}
            planFields={data.planFields}
          />
          <ShopAccountSection
            // Remounted with the server's (trimmed) values after its own save,
            // not when the client block changes: typed notes are kept.
            key={`account-${shopId}-${JSON.stringify([
              data.account.logistician,
              data.account.goLiveAt,
              data.account.notes,
            ])}`}
            shopId={shopId}
            account={data.account}
          />
          <ShopSettingsSection shopId={shopId} settings={data.settings} />
        </>
      )}
    </AdminPageShell>
  );
}
